import React from "react";
import LoadingScreen from "./LoadingScreen";

/**
 * Shown while a page's code is on its way.
 *
 * Each screen is fetched only when somebody goes to it, so there is a moment
 * between the click and the page. It holds a good part of the viewport height
 * so the footer does not jump up to meet the header on the way.
 */
const RouteFallback = () => <LoadingScreen message="Loading" />;

export default RouteFallback;
